import "./Example.css";

function Example() {


    return (
        <div className="exampleContainer">
        <h1>
            You're logged in!
        </h1>
        </div>
    )
}
export default Example;

